export const getSelectedMetadataViewKey = (
  categoryObjectKey: string,
  categoryName: string,
) => `${categoryObjectKey}:${categoryName}`;
